import { MakeRequest, ResponseData } from "./types";
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const data = localStorage.getItem("token");
  if (data && config.headers) {
    config.headers.token = JSON.parse(data);
  }

  return config;
});

export default <R>({
  url = "/",
  baseURL = process.env.REACT_APP_SERVER_URL,
  method = "get",
  params = {},
  data,
  headers = {},
  responseType = 'json'
}: MakeRequest): Promise<ResponseData<R>> => {
  return axios({
    url,
    baseURL,
    method,
    params,
    data,
    headers,
    responseType,
  }).then((res) => res.data);
};
